const riveAccountObject = {
    instances: {},
    status: -1,
    container: null,
    timer: null,
    initSecondRive: false,
    initialize: function () {
        if (this.status === -1) {
            this.status = 0;

            this.container = document.querySelector('.rive-account');

            const canvas1 = document.getElementById('rive-account__canvas-1');
            canvas1.setAttribute('width', Math.ceil(window.innerHeight * 0.54718).toString());
            canvas1.setAttribute('height', window.innerHeight.toString());

            this.instances['canvas-1'] = new rive.Rive({
                src: document.location.origin + '/i/instaforex/rive/mockup_section5.riv',
                canvas: canvas1,
                artboard: 'mockup_section5',
                layout: new rive.Layout({
                    fit: rive.Fit.Contain,
                    alignment: rive.Alignment.Center
                }),
                autoplay: false,
                onload: this.checkReadyRive.bind(this),
            });

            this.reactToResize();
        }
    },
    initializeSecondRave: function () {
        if (window.innerWidth < main.mobileResolutionBorder) return;
        if (this.initSecondRive) return;
        this.initSecondRive = true;

        const canvas2 = document.getElementById('rive-account__canvas-2');
        canvas2.setAttribute('width', Math.ceil(window.innerHeight * 0.54718).toString());
        canvas2.setAttribute('height', window.innerHeight.toString());

        this.instances['canvas-2'] = new rive.Rive({
            src: document.location.origin + '/i/instaforex/rive/mockup_section6.riv',
            canvas: canvas2,
            artboard: 'mockup_section6',
            stateMachines: 'state',
            layout: new rive.Layout({
                fit: rive.Fit.Contain,
                alignment: rive.Alignment.Center
            }),
            autoplay: false,
            onload: this.checkReadyRive.bind(this)
        });
    },
    checkReadyRive: function () {
        clearTimeout(this.timer);
        let ready = true;

        Object.keys(this.instances).map((key) => {
            const instance = this.instances[key];
            if (!instance.readyForPlaying) ready = false;
        });

        if (ready) {
            this.status = 1;
            main.setLoaderPercent(1);
        } else {
            this.timer = setTimeout(this.checkReadyRive.bind(this), 500);
        }
    },
    stopRendering: function (id) {
        this.instances['canvas-' + id].canvas.style.opacity = '0';
        this.instances['canvas-' + id].stopRendering();
    },
    startRendering: function (id) {
        accountObject.isHideAllCanvas = false;
        this.instances['canvas-' + id].canvas.style.opacity = '1';
        this.instances['canvas-' + id].startRendering();
    },
    play: function (id) {
        this.setBorderRadius();
        this.instances['canvas-' + id].play();
    },
    pause: function (id) {
        this.instances['canvas-' + id].pause();
    },
    reset: function (id) {
        this.instances['canvas-' + id].reset();
    },
    setBorderRadius: function () {
        this.container.style.borderRadius = Math.round(this.container.clientWidth * .13538) + 'px';
    },
    reactToResize: function () {
        this.initializeSecondRave();
        this.setBorderRadius();
    }
};
